import { Layout } from "antd";
import HeaderMenu from "./Components/HeaderMenu/HeaderMenu";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import PrivateRoute from "./Auth/PrivateRoute";
import WarehouseView from "./Views/Warehouse/WarehouseView";
import ProducersView from "./Views/Producers/ProducersView";
import ProductsView from "./Views/Products/ProductsView";
import LabelsView from "./Views/Labels/LabelsView";
import LoginView from "./Views/Login/LoginView";
import organicJPG from "./Assets/organic.jpg";
import organicJPGR90 from "./Assets/organic_90.jpg";
import organic203JPG from "./Assets/organic_203.jpg";
import testLabel from "./Assets/test_label.png";
import React from "react";
import { createBrowserHistory } from "history";
import { connect } from "react-redux";
import { AppState } from "./Store";
import { AuthState } from "./Store/Auth/reducers";
import { UserRoleEnum } from "./Models/Auth";
import BatchesView from "./Views/Batches/BatchesView";
import TelemaOrdersView from "./Views/TelemaOrders/TelemaOrdersView";
import TelemaBulkOrdersView from "./Views/TelemaBulkOrders/TelemaBulkOrdersView";
import TelemaRecAdvs from "./Views/TelemaRecAdvs/TelemaRecAdvs";
import TelemaStatistics from "./Views/TelemaStatistics/TelemaStatistics";
import WorkersView from "./Views/Workers/WorkersView";
import ContractsView from "./Views/Contracts/ContractsView";

const { Header, Footer, Sider, Content } = Layout;

const history = createBrowserHistory();
interface AppNavigatorProps {
  auth: AuthState;
}

function AppNavigator(props: AppNavigatorProps) {
  const {
    auth: { user },
  } = props;
  const PrivateContent = ({ children, ...rest }: any) => {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Header style={{ background: "white" }}>
          <HeaderMenu />
        </Header>
        <Content style={{ padding: "20px 50px 20px 50px" }}>{children}</Content>
      </Layout>
    );
  };

  return (
    <Router history={history}>
      <Switch>
        <PrivateRoute
          exact
          path={"/"}
          allowedRoles={[UserRoleEnum.ADMIN, UserRoleEnum.CLIENT]}
        >
          {user && user.role.type === UserRoleEnum.CLIENT && (
            <Redirect to={"/contracts"} />
          )}
          {user && user.role.type === UserRoleEnum.ADMIN && (
            <Redirect to={"/home"} />
          )}
        </PrivateRoute>
        <PrivateRoute path={"/home"} allowedRoles={[UserRoleEnum.ADMIN]}>
          <PrivateContent>
            <WarehouseView />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/contracts"}
          allowedRoles={[UserRoleEnum.ADMIN, UserRoleEnum.CLIENT]}
        >
          <PrivateContent>
            <ContractsView />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/batches"}
          allowedRoles={[UserRoleEnum.ADMIN]}
        >
          <PrivateContent>
            <BatchesView />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/producers"}
          allowedRoles={[UserRoleEnum.ADMIN]}
        >
          <PrivateContent>
            <ProducersView />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/products"}
          allowedRoles={[UserRoleEnum.ADMIN]}
        >
          <PrivateContent>
            <ProductsView />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/labels"}
          allowedRoles={[UserRoleEnum.ADMIN]}
        >
          <PrivateContent>
            <LabelsView />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/orders"}
          allowedRoles={[UserRoleEnum.ADMIN]}
        >
          <PrivateContent>
            <TelemaOrdersView />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/statistics"}
          allowedRoles={[UserRoleEnum.ADMIN]}
        >
          <PrivateContent>
            <TelemaStatistics />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/bulk-orders"}
          allowedRoles={[UserRoleEnum.ADMIN]}
        >
          <PrivateContent>
            <TelemaBulkOrdersView />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/recadvs"}
          allowedRoles={[UserRoleEnum.ADMIN]}
        >
          <PrivateContent>
            <TelemaRecAdvs />
          </PrivateContent>
        </PrivateRoute>
        <PrivateRoute
          exact
          path={"/workers"}
          allowedRoles={[UserRoleEnum.ADMIN]}
        >
          <PrivateContent>
            <WorkersView />
          </PrivateContent>
        </PrivateRoute>
        <Route path="/login">
          <LoginView />
        </Route>
        <Route path={"*"}>
          <Redirect to={"/"} />
        </Route>
      </Switch>

      <img
        src={organicJPG}
        id={"organic"}
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-200%",
          top: 0,
        }}
      ></img>
      <img
        src={organic203JPG}
        id={"organic_203"}
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-200%",
          top: 0,
        }}
      ></img>
      <img
        src={organicJPGR90}
        id={"organic_90"}
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-200%",
          top: 0,
        }}
      ></img>
      <img
        src={testLabel}
        id={"test_label"}
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-200%",
          top: 0,
        }}
      ></img>
    </Router>
  );
}

const mapStateToProps = (state: AppState) => ({
  auth: state.auth,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(AppNavigator);
